import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pf-compliance-view',
  templateUrl: './pf-compliance-view.component.html',
  styleUrls: ['./pf-compliance-view.component.css']
})
export class PfComplianceViewComponent implements OnInit {
  title="PF Compliance Details";
  

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/pf-compliances/pf-compliance-view/pf-compliance-view.component.ts